import { render, staticRenderFns } from "./FchzDetail.vue?vue&type=template&id=34a37f60&scoped=true&"
import script from "./FchzDetail.vue?vue&type=script&lang=js&"
export * from "./FchzDetail.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=34a37f60&prod&scoped=true&lang=css&"
import style1 from "../detail.css?vue&type=style&index=1&id=34a37f60&prod&scoped=true&lang=css&"
import style2 from "./FchzDetail.vue?vue&type=style&index=2&id=34a37f60&prod&scoped=true&lang=css&"
import style3 from "./FchzDetail.vue?vue&type=style&index=3&id=34a37f60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a37f60",
  null
  
)

export default component.exports